import { RANK, createTopPostsControls } from './topPostsControls';
import { TIKTOK_METADATA_BY_KEY } from 'utils/metrics';

/**
 * The member names below are the ones callers reference (see
 * TopPostsDrawerRelatedHashtags.jsx).
 */
export const RANK_TYPES = {
    LAST_WEEK_VIEWS: RANK.LAST_WEEK,
    AVG_WEEKLY_VIEWS: RANK.AVG_WEEKLY,
    TOTAL_POST_VIEWS: RANK.TOTAL_POST,
};

export const useTopPostsControls = createTopPostsControls({
    metadata: TIKTOK_METADATA_BY_KEY,
    // These reach the API as `rank_type` and enter queryKey[1]; byte-identical.
    metricKeys: {
        [RANK.LAST_WEEK]: 'last_week_views',
        [RANK.AVG_WEEKLY]: 'avg_weekly_views',
        [RANK.TOTAL_POST]: 'total_post_views',
    },
    wowKey: 'non_cum_WoW',
    // Mixpanel `Change` property values. External reports segment on these.
    eventRankTypes: {
        [RANK.LAST_WEEK]: 'LAST_WEEK_VIEWS',
        [RANK.AVG_WEEKLY]: 'AVG_WEEKLY_VIEWS',
        [RANK.TOTAL_POST]: 'TOTAL_POST_VIEWS',
    },
});

export default useTopPostsControls;
